import PropTypes from 'prop-types';

import styles from './index.styl';


function Other({ videoId }) {
  return (
    <div className={styles.frameWrapper}>
      <iframe
        src={videoId}
        allowFullScreen
        frameBorder='0'
        scrolling='no'
        allow='autoplay; encrypted-media; fullscreen; picture-in-picture; accelerometer; gyroscope;'
      />
    </div>
  );
}

Other.propTypes = {
  videoId: PropTypes.string,
};

export default Other;
